import { Injectable } from '@angular/core';
import { CartProducts, Products } from '../modules/shop/types/products';
import { BehaviorSubject, forkJoin, Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { CommonService } from './common-services/common.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  baseUrl = environment.BASE_URL;

  public cartUpdates = new Subject<any>();
  public cartUpdates$ = this.cartUpdates.asObservable();

  public cartItems: CartProducts[] = [];
  shopBaseUrl = environment.SHOP_BASE_URL;
  shopBaseUrl2 = environment.SHOP_BASE_URL2
  categories: any[] = [];
  productIdCategoryId: Map<number, number[]> = new Map();
  public get count(): number {
    return this.cartItems.reduce((c, t1) => t1.qty + c, 0);
  }

  public cartUrl = new BehaviorSubject<number>(0);
  public cartUrl$ = this.cartUrl.asObservable();
  constructor(private commonService: CommonService, private http:HttpClient) {}

  // addToCart(product:Products) {
  //   let item:CartProducts = this.cartItems.find(item => item.id === product.id) as CartProducts;
  //   if(item) {
  //     item.qty ++;
  //   } else {
  //     (product as CartProducts).qty = 1;
  //     this.cartItems.push(product)
  //   }
  //   this.cartUpdates.next(this.cartUpdates);
  // }

  updateProductId(productId: number) {
    this.cartUrl.next(productId);
  }

  getCartItems(id?: number) {
    let setCompanyId;
    const companyId = localStorage.getItem('customercompanyId');
    if (id) {
      setCompanyId = id;
    } else {
      setCompanyId = companyId;
    }
    let cartApi = `${this.baseUrl}rfq/cart/getCartItem?companyId=${setCompanyId}`;
    this.commonService.getData(cartApi).subscribe((data) => {
      this.cartItems = data;
      this.cartUpdates.next(this.cartItems);
    });
  }

  getAllCategories(): void {
    let apiUrl = `${this.shopBaseUrl}categories?page=1&limit=1000`;
    this.commonService.getData(apiUrl).subscribe({
      next: (data: any) => {
        this.categories = data?.data;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
    });
  }

  getAllProductIdCategoryId(): void {
    //let apiUrl = 'https://shop.unibuild.ai/api/v1/getAll-productId-categoryId';
    let apiUrl = `${this.shopBaseUrl2}v1/getAll-productId-categoryId`;
    this.commonService.getData(apiUrl).subscribe({
      next: (data: any) => {
        data?.forEach((obj: any) => {
          if (this.productIdCategoryId.has(obj.product_id)) {
            const productId = this.productIdCategoryId.get(obj.product_id);
            productId?.push(obj.category_id);
          } else {
            this.productIdCategoryId.set(obj.product_id, [obj.category_id]);
          }
        });
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
    });
  }
}
